import {
  addressNoMilitarySchema,
  addressNoMilitaryUI,
  textUI,
  textSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { validateWhiteSpace } from 'platform/forms/validations';

const uiSchema = {
  ...titleUI(
    'The name and mailing address of the organization giving the prep course',
    'Provide the name of the organization giving the prep course.',
  ),
  prepCourseOrganizationName: {
    ...textUI({
      title: 'Organization name',
      required: () => true,
      validations: [validateWhiteSpace],
      errorMessages: {
        required: 'Enter the name of the organization',
      },
    }),
  },
  prepCourseOrganizationAddress: addressNoMilitaryUI(),
};

const schema = {
  type: 'object',
  properties: {
    prepCourseOrganizationName: textSchema,
    prepCourseOrganizationAddress: addressNoMilitarySchema({
      omit: ['country'],
      extend: {
        street: { maxLength: 50 },
        street2: { maxLength: 50 },
        city: { maxLength: 51 },
      },
    }),
  },
  required: ['prepCourseOrganizationName', 'prepCourseOrganizationAddress'],
};

export { schema, uiSchema };
